import { ModelBase } from 'store/model-base';
import { RetryPaymentCode } from 'my-account/constants';

export class RetryPaymentResult extends ModelBase {
    public static storeName: string = 'retryPaymentResult';

    public state: string;
    public saveCard: boolean;
    public paidAmount: number;
    public pastDueAmount: number;
    public errorCode: RetryPaymentCode;
    public message: string;
    public description: string;
}
